import { todayLocal } from "@/lib/dates";

/**
 * How a person's role assignments are classified as previous / future /
 * current. Derived from the dates on every read — a role moves between
 * buckets as time passes, with no data change.
 *
 * Shared because the profile header and the roles panel must agree: the
 * header names "who they are now", which is the same test the panel's
 * Current tab applies.
 */

/** Previous once the end date has passed (strictly before today). */
export function roleIsPrevious(endDate: string | null): boolean {
  return Boolean(endDate) && (endDate ?? "") < todayLocal();
}

/** Future while the start date is still ahead of today. */
export function roleIsFuture(startDate: string | null): boolean {
  return Boolean(startDate) && (startDate ?? "") > todayLocal();
}

/** Neither ended nor yet to start. */
export function roleIsCurrent(role: { startDate: string | null; endDate: string | null }): boolean {
  return !roleIsPrevious(role.endDate) && !roleIsFuture(role.startDate);
}
